import { useEffect, useCallback } from 'react'
import { type UseDragAndDropProps } from './fileUploader.types'

export const useDragAndDrop = ({
  dropAreaRef,
  onDragStart,
  onDragEnd,
  onDrop,
}: UseDragAndDropProps) => {
  const preventDefaults = useCallback((e: Event) => {
    e.preventDefault()
    e.stopPropagation()
  }, [])

  useEffect(() => {
    const dropArea = dropAreaRef.current
    if (!dropArea) return

    const handleDragEnter = (e: DragEvent) => {
      preventDefaults(e)
      onDragStart()
    }

    const handleDragOver = (e: DragEvent) => {
      preventDefaults(e)
      onDragStart()
    }

    const handleDragLeave = (e: DragEvent) => {
      preventDefaults(e)
      onDragEnd()
    }

    const handleDrop = (e: DragEvent) => {
      preventDefaults(e)
      onDragEnd()
      onDrop(e)
    }

    // Add event listeners
    dropArea.addEventListener('dragenter', handleDragEnter, false)
    dropArea.addEventListener('dragover', handleDragOver, false)
    dropArea.addEventListener('dragleave', handleDragLeave, false)
    dropArea.addEventListener('drop', handleDrop, false)

    // Clean up
    return () => {
      dropArea.removeEventListener('dragenter', handleDragEnter, false)
      dropArea.removeEventListener('dragover', handleDragOver, false)
      dropArea.removeEventListener('dragleave', handleDragLeave, false)
      dropArea.removeEventListener('drop', handleDrop, false)
    }
  }, [dropAreaRef, preventDefaults, onDragStart, onDragEnd, onDrop])
}
